export const NOT_FOUND_INDEX = -1;

export const TEST_ID = 'intervalUnitToggle';
